import React from "react";
import {oneOf} from "prop-types";
import {COPYRIGHT_STRING, PRIVACY_POLICY_URL, VAT, COPYRIGHT_STRING_2, COOKIE_POLICY_URL} from "constants.js";
import "./index.scss";
import {__} from "services/i18n";
function Footer(props) {
    const {type} = props;
    return (
        <div className={`footer ${type}`}>
            <p>{COPYRIGHT_STRING} | {__("footer.vat")} {VAT} | {COPYRIGHT_STRING_2} | <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">{__("footer.privacy")}</a> | <a href={COOKIE_POLICY_URL} target="_blank" rel="noopener noreferrer">Cookie Policy</a></p>
        </div>
    )
}

Footer.propTypes = {
    type: oneOf(["dark", "light"]).isRequired
}

export default Footer;